// import { fetchPlacementOfficer } from '@/redux/slice/placementOfficer.slice';
import axiosConfig from './axios.service';
import config from '@/config/api-config';
// import { getClgToken } from '@/utils/storage';
// import { v4 as uuidv4 } from 'uuid';


// Get Placement Officer data
export const getPlacementOfficer = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/user-data`);
        // dispatch(fetchPlacementOfficer(response.data));
        return response.data;
    } catch (error) {
        return error;
    }
};

export const getAddress = async (isBilling) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/address`, {
            params: { isBilling }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

// Submit address information
export const submitAddress = async (data ) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/address`, data);
        return response.data;

    } catch (error) {
        return error;
    }
};
// Submit address information
export const updateAddress = async (data, id) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/address/${id}`, data);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const fetchPlans = async ( ) =>{
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/plans`);
        return response.data;
    } catch (error) {
        return error;
    }
}

// Submit pricing details
export const submitPricing = async (planId) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/billing`, {planId:planId},{
            // headers:{
            //     'show-toast': 'false',
            // }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};
export const updatePricing = async (id,data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/billing/${id}`, data ,{},{
            headers:{
                'show-toast': 'false',
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

// Fetch list of universities
export const fetchUniversities = async (university_name = '', next = '') => {
    try {
        const res = await axiosConfig.get(`${config.API_ROOT_PO}/university`, {
            params: { university_name, next }
        });
        const myOptions = res.data.universities.map(item => ({
            label: item.name,
            value: item.id,
        }));
        return { myOptions, next: res.data.next };
    } catch (error) {
        return error;
    }
};

// Submit college information
export const submitCollegeInfo = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/college-info`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}


// Submit contact information
export const submitContactInfo = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/personal-info`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}


// get all student data

export const getAllStudentData = async (params = {}) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-info`, {
            params // `mode` is now included in the `params` object
        });
        return response.data;
    } catch (error) {
        return error;
    }
};


// Update Student Status function
// export const UpdateStudentStatus  = async (id, data) => {
//     try {
//         const response = await axiosConfig.put(`${config.API_ROOT_PO}/status-update/${id}`, data);

//         return response.data;
//     }
//     catch (error) {
//         return { errors: error };
//     }
// };


export const fetchAllStudentData = async (params = {}) => {
    try {
        const response = await axiosConfig.get(
            `${config.API_ROOT_PO}/student-info-all`,
            {
                params,
            }
        );
        return response.data;
    } catch (error) {
        throw new Error("Failed to fetch student data");
    }
};

export const fetchStudentEduInfo = async (id) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_STUDENT}/education-info/${id}`);
        return response.data;
    } catch (error) {
        return error

    }
}
export const fetchAllDepartment = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/department`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchAllStudentSkills = async (params) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-skills`, {
            params
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchAllStudentDomains = async (params) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-domain`, {
            params
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const UpdateStudentStatus = async (studentIds, newStatus, mode) => {
    try {
        const studentIdArray = Array.isArray(studentIds) ? studentIds : [studentIds];

        const studentIdParam = JSON.stringify(studentIdArray);

        const response = await axiosConfig.put(`${config.API_ROOT_PO}/status-update?studentId=${studentIdParam}&mode=${mode}`, {
            status: newStatus,
        });

        return response.data;
    } catch (error) {
        return { errors: error };
    }
};


export const CreateArchivedStudent = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/archive`, data);
        return response.data
    }
    catch (error) {
        return error
    }
};

export const fetchAllArchive = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/archive`);
        return response.data;
    } catch (error) {
        return error;
    }
};

export const UpdateArchivedStudent = async (id, data, headers = {}) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/archive/${id}`, data, {
            headers: headers
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const deleteArchivedStudent = async (domainId, params = {}) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/remove-archive-student/${domainId}`, {
            params
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchArchiveStudents = async (id, params = {}) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/archive/${id}`, {
            params
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const DeleteArchived = async (id) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/archive/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const CreateBookmark = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/bookmark`, data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchAllBookmarks = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/bookmark`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const UpdateBookmarkStudent = async (id, data, headers = {}) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/bookmark/${id}`, data, {
            headers: headers
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const deleteBookmarkStudetns = async (domainId, params = {}) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/remove-bookmark-student/${domainId}`, {
            params
        })
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchBookMarkedStudents = async (id, params) => {
    try {
        const encodedId = encodeURIComponent(id); // Encode the id
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/bookmark/${encodedId}`, {
            params // No need to encode params
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const DeleteBookmark = async (id) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/bookmark/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchAllSearchData = async (searchQuery) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/all-search`, {
            params: {
                search: searchQuery
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}


export const fetchActionSearchData = async (type, searchQuery) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/all-action-search`, {
            params: {
                type,
                search: searchQuery,
            },
        });
        return response;
    } catch (error) {
        console.error('API call error:', error);
        return error;
    }
};

export const fetchStudentStatus = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-status`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}


export const fetchApprovalSearchData = async (searchQuery) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/approval-search`, {
            params: {
                search: searchQuery
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchDashboardDept = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/buildin-dashboard-group`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const fetchSingleDeptData = async (id) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/dashboard-department/${id}`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}


export const fetchBuildInDashStudent = async (id, params = {}) => {
    const cleanedParams = Object.fromEntries(
        Object.entries(params).filter(([, value]) => {
            if (Array.isArray(value)) {
                return value.length > 0;
            }
            return value !== undefined && value !== null && value !== '';
        })
    );

    try {
        const response = await axiosConfig.get(
            `${config.API_ROOT_PO}/dashboard-department-student/${id}`,
            { params: cleanedParams }
        );
        return response.data;
    } catch (error) {
        console.error('Error fetching dashboard students:', error);
        return { error: true, message: 'Failed to fetch dashboard students', details: error };
    }
};

export const getCollegeInfo = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/college-info`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

// Update College Information
export const updateCollegeInfo = async (data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/update-college-info`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const DeleteProfilePicture = async () => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/college-profile`);
        return response.data;
    } catch (error) {
        return error;
    }
}

// Update College profile
export const updateCollegeProfile = async (data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/college-profile`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

// Submit major and department information in bulk
export const submitMajorAndDepartments = async (degreeData) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/majors-bulk`, degreeData);
        return response.data;
    } catch (error) {
        return error;
    }
};

// Submit College Infrastructure
export const submitCollegeInfrastructure = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/college-infrastructure`, data, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export const updateCollegeInfrastructure = async (id, data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/college-infrastructure/${id}`, data,
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
}


export const deleteCollegeInfrastructure = async (id) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/college-infrastructure/${id}`
        );
        return response.data;
    } catch (error) {
        return error;
    }
}

export const removeDepartments = async (data) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/remove-departments`, { data: data })
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const updateBulkMajor = async (data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/update-bulk-major`, data)
        return response.data;
    }
    catch (error) {
        return error;
    }
}

// Fetch college data 

export const fetchCollegeData = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/college-data`);
        return response.data;
    } catch (error) {
        return error;
    }
}


export const fetchDepartmentTopSkill = async ({ id }) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/department-top-skill/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}
//fetch  Students Placement

export const fetchStudentsPlacement = async (params = {}, placed) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-placement`, {
            params: { ...params, placed }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching non-placed students:', error);
        return { error: true, message: 'Failed to fetch non-placed students', details: error };
    }
};


export const fetchStudentPlacementSearch = async (searchQuery, placed) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-placement-status-search`, {
            params: {
                search: searchQuery,
                placed
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
}

export const fetchWidgets = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/widgets`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const createQuickAction = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/quick-access`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
}
export const fetchQuickAction = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/quick-access`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}
export const deleteQuickAction = async ({ id }) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/quick-access/${id}`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const fetchProfileProgress = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/progress`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const updatePlacementStatus = async (studentIds, placementData) => {
    try {
        const studentIdArray = Array.isArray(studentIds) ? studentIds : [studentIds];
        const encodedIds = encodeURIComponent(JSON.stringify(studentIdArray));

        const response = await axiosConfig.put(`${config.API_ROOT_PO}/placement-status?studentId=${encodedIds}`, {
            isPlaced: placementData.isPlaced // Now sending as an object with isPlaced property
        });

        return response.data;
    } catch (error) {
        if (error.response?.data) {
            return error.response.data;
        }
        return { success: false, message: ["Something went wrong"] };
    }
};


export const uploadCSVFileData = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.AUTH_API_ROOT_PO}/student-excel-upload`, data, {
            headers: { 'Content-Type': 'multipart/form-data', 'show-loader': 'false' },
        });
        return response.data; // Return the response data directly
    }
    catch (error) {
        return error;
    }
}

export const getInvitedStudents = async (params = {}) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/invited-students`, {
            params
        });
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const deleteInvitedStudents = async (studentIds) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/remove-invited-students`, {
            params: {
                studentId: JSON.stringify(studentIds)
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting student(s):", error);
        return error.response ? error.response.data : error.message;
    }
};


// export const getBillingAddress = async()=>{
//     try{
//         const response = await axiosConfig.get(`${config.API_ROOT_PO}/billing-address`);
//         return response.data;
//     }
//     catch(error) {
//         return error;
//     }
// }

export const getSecurity = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/security`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const changePassword = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.AUTH_API_ROOT_PO}/change-password`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const getAccountDetails = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/account-settings`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}
export const updateProfileAccountDetails = async (data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/account-settings`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
}


export const fetchStudentPersonalDocs = async (id) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/student-personal-document/${id}`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const twoStepVerificationOTPSent = async () => {
    try {
        const response = await axiosConfig.post(`${config.AUTH_API_ROOT_PO}/two-step-verification`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}


export const verifyTwoStepVerification = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.AUTH_API_ROOT_PO}/two-step-verify-otp`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const createTodoList = async (data) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/todolist`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const getCompaniesList = async (params = {}) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/company-listing`, {
            params
        });
        return response.data;
    }
    catch (error) {
        console.error("Error fetching companies list:", error);
        throw error;
    }
}

export const getCompanyConnectionStatus = async (params = {}) =>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/company-connection-listing`, {
            params
        });
        return response.data;
    }
    catch (error) {
        return error;
    }

}

export const getCompanyByStatus = async (params = {})=>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/connection-status`, {
            params
        });
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const getCompaniesDataById = async (id) => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/company-info/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const connectHr = async (id,status) => {
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/connect-hr`, {
            companyId: id,
            status: status
        },{
            headers: {
                // "show-toast": "false",
                "show-loader": "false",
            }
        });
        return response.data;
    } catch (error) {
        return error
    }
}

export const approveConnectionRequest = async (id, status) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/connection-approval/${id}`, {
            status: status
        },{
        });
        return response.data;
    } catch (error) {
        return error
    }
}


export const getTodoList = async () => {
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/todolist`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}

export const updateTodoList = async (id, data) => {
    try {
        const response = await axiosConfig.put(`${config.API_ROOT_PO}/todolist/${id}`, data);
        return response.data;
    }
    catch (error) {
        return error;
    }
}
export const deleteTodoList = async (id) => {
    try {
        const response = await axiosConfig.delete(`${config.API_ROOT_PO}/todolist/${id}`);
        return response.data;
    }
    catch (error) {
        return error;
    }
}


export const SummeryMetric =async(status) =>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/approval-summery-metric/`,{
            params:{
                status:status
            }
        });
        return response.data;
    }
    catch(error){
        return error;
    }
}


export const getLocationSort = async (data) => {
    try {
      const response = await axiosConfig.get(`${config.API_ROOT_PO}/location`, {
        params: { city: data.city },
      });
      return response.data;
    } catch (error) {
      return error;
    }
  };

  export const getSectors = async(data) =>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_HR}/sectors`,{
            params: { sector: data.name },
        });
        return response.data;
    }
    catch(error){
        return error;
    }
  }


  export const getConnectedChart = async()=>{
    try{
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/connection-graph`)
        return response.data;
    }
    catch(error){
        return error;
    }
  }
  

  export const sentFAQ = async (data) =>{
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/faq`,data);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getPlanDetails  = async () =>{
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/plans`);
        return response.data;
    } catch (error) {
        return error;
    }
}


export const getInvoice = async (id)=>{
    try {
        const response = await axiosConfig.post(`${config.API_ROOT_PO}/invoice/${id}`);
        return response.data;
    } catch (error) {
        return error;
    }
}

export const getPaymentList = async () =>{
    try {
        const response = await axiosConfig.get(`${config.API_ROOT_PO}/college-plans-listing`);
        return response.data;
    } catch (error) {
        return error;
    }
}